import { Link } from "react-router-dom";
import { useEffect } from "react";

const containerStyle = {
  maxWidth: 780,
  margin: "0 auto",
  padding: "40px 24px 80px",
  color: "var(--fg)",
  lineHeight: 1.6,
} as const;

const h2 = {
  fontSize: 20,
  fontWeight: 700,
  marginTop: 32,
  marginBottom: 10,
  color: "var(--fg)",
} as const;

export function TermsPage() {
  useEffect(() => { document.title = "CGU — sonslow"; }, []);
  const today = new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" });

  return (
    <div style={containerStyle}>
      <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 4 }}>Conditions générales d'utilisation</h1>
      <p style={{ color: "var(--fg-mute)", fontSize: 13, marginBottom: 20 }}>Dernière mise à jour : {today}</p>

      <section>
        <h2 style={h2}>1. Nature du service</h2>
        <p>
          sonslow est un service personnel non lucratif de streaming musical, fondé sur l'agrégation des catalogues
          Spotify (métadonnées) et Deezer (flux audio). Le service ne stocke aucun fichier audio de manière permanente
          et fonctionne comme un intermédiaire technique entre l'utilisateur et les catalogues sources.
        </p>
      </section>

      <section>
        <h2 style={h2}>2. Accès et compte</h2>
        <p>
          L'accès à sonslow requiert la création d'un compte gratuit. L'utilisateur s'engage à fournir des informations
          exactes et à préserver la confidentialité de son mot de passe. Un compte est nominatif et personnel.
        </p>
      </section>

      <section>
        <h2 style={h2}>3. Usage acceptable</h2>
        <p>L'utilisateur s'engage à :</p>
        <ul style={{ paddingLeft: 22, marginTop: 6 }}>
          <li>Ne pas partager son compte ni ses identifiants avec des tiers</li>
          <li>Ne pas scraper, automatiser ou surcharger volontairement le service</li>
          <li>Ne pas contourner les mesures anti-abus (rate-limiting, quota d'écoute)</li>
          <li>Ne pas tenter de télécharger ni de redistribuer les flux audio reçus</li>
        </ul>
        <p>Le non-respect entraîne la suspension immédiate du compte sans préavis.</p>
      </section>

      <section>
        <h2 style={h2}>4. Contenus tiers</h2>
        <p>
          Les catalogues et flux audio proviennent de Spotify et Deezer, tiers indépendants sur lesquels sonslow n'a
          aucun contrôle éditorial. La disponibilité, la qualité et l'accès aux œuvres dépendent des politiques de ces
          plateformes. sonslow agit en qualité d'intermédiaire technique passif au sens de la Directive européenne
          2000/31/CE sur le commerce électronique.
        </p>
      </section>

      <section>
        <h2 style={h2}>5. Signalement de contenu</h2>
        <p>
          Tout ayant droit peut signaler un contenu litigieux via{" "}
          <a href="https://t.me/slowtlks" target="_blank" rel="noopener noreferrer">Telegram</a>.
          Le titre concerné sera retiré du catalogue exposé dans les meilleurs délais après vérification.
        </p>
      </section>

      <section>
        <h2 style={h2}>6. Suspension et résiliation</h2>
        <p>
          L'utilisateur peut supprimer son compte à tout moment depuis ses <Link to="/settings">Paramètres</Link>.
          L'opérateur se réserve le droit de suspendre ou de fermer un compte en cas de non-respect des présentes CGU,
          sans indemnité.
        </p>
      </section>

      <section>
        <h2 style={h2}>7. Absence de garantie</h2>
        <p>
          Le service est fourni « tel quel », sans garantie de disponibilité ininterrompue, d'exhaustivité du catalogue
          ou de qualité audio. La responsabilité de l'opérateur ne saurait être engagée pour un dommage direct ou
          indirect résultant de l'utilisation ou de l'indisponibilité du service.
        </p>
      </section>

      <section>
        <h2 style={h2}>8. Propriété intellectuelle</h2>
        <p>
          Le nom sonslow, le code source, l'interface et les visuels du service sont la propriété exclusive de son
          auteur. Les métadonnées et œuvres musicales appartiennent à leurs ayants droit respectifs.
        </p>
      </section>

      <section>
        <h2 style={h2}>9. Droit applicable</h2>
        <p>
          Les présentes CGU sont soumises au droit belge. Tout litige relève de la compétence exclusive des tribunaux
          de Bruxelles.
        </p>
      </section>

      <div style={{ marginTop: 40, paddingTop: 24, borderTop: "1px solid var(--line)" }}>
        <Link to="/" style={{ color: "var(--fg-mute)", fontSize: 13 }}>← Retour à l'accueil</Link>
      </div>
    </div>
  );
}
